import React, { useState, useEffect, useContext } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddEditCustomer from "./AddEditCustomer";
import { FilterMatchMode } from "primereact/api";
import LoadingOverlay from "react-loading-overlay";
import { Triangle } from "react-loader-spinner";
import { InputText } from "primereact/inputtext";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { Divider } from "primereact/divider";
import { handleDeleteRequest } from "../../services/DeleteTemplate";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import deleteIcon from "../../assets/farmkar_assets/Png/delete.png";
import editIcon from "../../assets/farmkar_assets/Png/edit.png";
import viewIcon from "../../assets/farmkar_assets/Png/view.png";
import CustomDeleteDialog from "../../components/CustomDeleteDialog";
import { baseURL } from "../../Config";
import { Image } from "primereact/image";
import { Tag } from "primereact/tag";
import { Calendar } from "primereact/calendar";
import * as XLSX from "xlsx";
import moment from "moment";

const CustomerManagement = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [isActive, setIsActive] = useState(false);
    const [userRowData, setUserRowData] = useState();
    const [addEditUser, setAddEditUser] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [viewDisable, setViewDisable] = useState(false);
    const [referral, setReferral] = useState(false);
    const [date, setDate] = useState("");
    const [referralText, setReferralText] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="">
                <Button className="edit-icon ml-2" onClick={() => handleEditUsers(rowData)}>
                    <img src={editIcon} alt="Edit" />
                </Button>
                <Button className="del-icon" onClick={() => confirm(rowData)}>
                    <img src={deleteIcon} alt="Delete" style={{ width: "35px" }} />
                </Button>
            </div>
        );
    };

    const confirm = (rowData) => {
        const acceptAction = () => handleDeleteUser(rowData);
        confirmDialog({
            message: <CustomDeleteDialog message="Are you sure you want to delete this user?" acceptAction={acceptAction} />,
            header: "Confirmation",
            accept: acceptAction,
            reject: null,
            draggable: false,
            resizable: false,
        });
    };

    const handleDeleteUser = async (rowData) => {
        setIsActive(true);
        const response = await dispatch(handleDeleteRequest(`/api/v1/farmer/delete/${rowData?.id}`, true, true));
        if (response) {
            await getCustomersList();
        }
        setIsActive(false);
    };

    const handleEditUsers = (rowData) => {
        setDisplayDialog(true);
        setAddEditUser(true);
        setUserRowData(rowData);
    };

    const handleViewUser = (rowData) => {
        setDisplayDialog(true);
        setAddEditUser(true);
        setViewDisable(true);
        setUserRowData(rowData);
    };

    const onHide = () => {
        setDisplayDialog(false);
        setAddEditUser(false);
        setViewDisable(false);
    };

    const handleDialog = () => {
        setDisplayDialog(true);
    };

    const handleReferral = () => {
        setReferral(!referral);
    };

    const handleSearch = async () => {
        setIsActive(true);
        const response = await dispatch(handleGetRequest(`/api/v1/farmer/stats?referral=${referralText}&createdDate=${date ? moment(date).format("DD-MM-YYYY") : null}`, true));
        if (response?.statusCode === 200) {
            setAllUsers(response?.data);
        }
        setIsActive(false);
    };

    const getCustomersList = async () => {
        setIsActive(true);
        const response = await dispatch(handleGetRequest("/api/v1/farmer/getAll", true));
        if (response) {
            setAllUsers(response?.data);
        }
        setIsActive(false);
    };

    useEffect(() => {
        getCustomersList();
    }, []);

    const exportExcel = () => {
        const dataToExport = allUsers?.map((client) => ({
            Name: client?.name || "N/A",
            UrduName: client?.urduName || "N/A",
            Referral: client?.referral || "N/A",
            Contact: client?.phone || "N/A",
            CNIC: client?.cnic || "N/A",
            CreatedAt: moment(client?.createdAt).format("DD-MM-YYYY") || "N/A",
            Status: client?.status || "Inactive",
            FormDate: client?.formDate ? moment(client?.formDate).format("DD-MM-YYYY") : "N/A",
            EndDate: client?.endDate ? moment(client?.endDate).format("DD-MM-YYYY") : "N/A",
            TotalRequest: client?.totalRequest || 0,
            CompletedRequest: client?.completedRequest || 0,
            CompletedRequestRent: client?.completedRequestRent || 0,
            PendingRequest: client?.pendingRequest || 0,
            PendingRequestRent: client?.pendingRequestRent || 0,
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "All Customers List");
        XLSX.writeFile(workbook, "AllClients.xlsx");
    };

    const imageTemplate = (rowData) => {
        return <>{referral ? <Image src={`${baseURL}/${rowData?.farmerProfileImg}`} zoomSrc={`${baseURL}/${rowData?.farmerProfileImg}`} alt="Image" preview /> : <Image src={`${baseURL}/${rowData?.farmerProfileImg}`} zoomSrc={`${baseURL}/${rowData?.farmerProfileImg}`} alt="Image" preview />}</>;
    };

    const Header = () => {
        return (
            <>
                <h3 className="pr-2 pl-2 text-center" style={{ fontWeight: "600" }}>
                    {addEditUser && !viewDisable ? "Edit Customer" : viewDisable && addEditUser ? "View Details" : "Add Customer"}
                </h3>
                <div className="mt-2">
                    <hr />
                </div>
            </>
        );
    };

    return (
        <>
            <Dialog draggable={false} resizable={false} header={Header} visible={displayDialog} style={{ width: "64vw" }} onHide={onHide}>
                <AddEditCustomer onHide={onHide} getCustomersList={getCustomersList} addEditUser={addEditUser} userRowData={userRowData} viewDisable={viewDisable} />
            </Dialog>

            <div className="card dark-bg">
                <LoadingOverlay
                    active={isActive}
                    spinner={<Triangle height="120" width="120" color="#798403" ariaLabel="triangle-loading" visible={true} />}
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: "rgb(38 41 51 / 78%)",
                        }),
                    }}
                >
                    <DataTable
                        header={
                            <>
                                <div className="flex justify-content-between custom-alignment" style={{ display: "flex", alignItems: "center" }}>
                                    <div>
                                        <span className="search-container">
                                            <i className={globalFilterValue ? "" : "pi pi-search search-icon"} />
                                            <InputText placeholder="Search" value={globalFilterValue} onChange={onGlobalFilterChange} className="search-input mb-3" />
                                        </span>
                                    </div>

                                    <div>
                                        <Button label="Search via Referral" className="Add__New-Button mb-2 mr-2" icon={referral ? "pi pi-arrow-up" : "pi pi-arrow-down"} onClick={handleReferral} />
                                        {/* <Button label="Add New" className="Add__New-Button mb-2" icon="pi pi-plus" onClick={handleDialog} /> */}
                                    </div>
                                </div>
                                {referral && (
                                    <div
                                        className="flex justify-content-between custom-alignment"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            borderBottom: "1px solid #ccc",
                                        }}
                                    >
                                        <div>
                                            <Button disabled={allUsers === undefined} label="Export Excel" className="Add__New-Button mb-2 mr-2" icon="pi pi-file-excel" onClick={exportExcel} />
                                        </div>
                                        <div id="date">
                                            <span className="search-constainer">
                                                <InputText placeholder="Search via referral" value={referralText} onChange={(e) => setReferralText(e.target.value)} className="search-input mb-3 mr-2" />
                                            </span>
                                            <Calendar placeholder="--Select Date--" id="buttondisplay" className="mb-2 mr-2" value={date} onChange={(e) => setDate(e.target.value)} showIcon maxDate={new Date()} />
                                            <Button label="Search" className="Add__New-Button mb-3" icon="pi pi-search" onClick={handleSearch} />
                                        </div>
                                    </div>
                                )}
                            </>
                        }
                        responsive={true}
                        filters={filters}
                        globalFilterFields={["name", "cnic", "urduName", "phone", "isActive", "cnic", "CreatedAt", "referral"]}
                        responsiveLayout="scroll"
                        stripedRows
                        paginator
                        rows={20}
                        value={allUsers}
                        emptyMessage="No records found"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    >
                        <Column body={imageTemplate} header="Profile Image" />
                        <Column field="name" header="Name" />
                        <Column field="urduName" header="Urdu Name" />
                        <Column field="referral" body={(rowData) => rowData?.referral || "N/A"} header="Referral" />
                        <Column field="phone" header="Contact No." />
                        <Column field="cnic" header="CNIC" />
                        <Column field="createdAt" body={(rowData) => moment(rowData?.createdAt).format("DD-MM-YYYY") || "N/A"} header="Created At" />
                        <Column body={(rowData) => <Tag style={{ fontSize: "11px", padding: "3px 6px" }} value={rowData?.status || "Inactive"} severity={rowData?.status === "Active" ? "success" : "danger"} />} header="Status" />
                        <Column field="formDate" body={(rowData) => (rowData?.formDate ? moment(rowData.formDate).format("DD-MM-YYYY") : "N/A")} header="From Date" />

                        <Column field="endDate" body={(rowData) => (rowData?.endDate ? moment(rowData.endDate).format("DD-MM-YYYY") : "N/A")} header="End Date" />
                        <Column field="totalRequest" body={(rowData) => rowData?.totalRequest || 0} header="Total Request" />
                        <Column field="completedRequest" body={(rowData) => rowData?.completedRequest || 0} header="Completed Request" />
                        <Column field="completedRequestRent" body={(rowData) => rowData?.completedRequestRent || 0} header="Completed Request Rent" />
                        <Column field="pendingRequest" body={(rowData) => rowData?.pendingRequest || 0} header="Pending Request" />
                        <Column field="pendingRequestRent" body={(rowData) => rowData?.pendingRequestRent || 0} header="Pending Request Rent" />
                        <Column header="Action" body={actionTemplate} />
                    </DataTable>
                </LoadingOverlay>
            </div>
        </>
    );
};

export default CustomerManagement;
